import styled, { css } from 'styled-components';

import { EColor, EFontWeight, EIcon, ESize } from '@core/type';

import { Button } from '../button';
import { TagProps } from './interface-tag';

const TagStyled = styled(Button)(
  () => css`
    transition: 0.5s;
    letter-spacing: 0.1px;
    padding: 2px 8px;
  `,
);

export const Tag = ({
  title,
  color,
  onClick,
  isActive,
  disabled,
  variant,
}: TagProps): JSX.Element => {
  return (
    <TagStyled
      endIcon={isActive ? EIcon.TAG_CROSS : null}
      iconSize={ESize.SM}
      size={ESize.XS}
      variant={variant}
      onClick={onClick}
      color={color || EColor.SECONDARY}
      colorIcon={EColor.ACCENT}
      fontWeight={EFontWeight.MEDIUM}
      disabled={disabled}
      isTransparent={false}
    >
      {title}
    </TagStyled>
  );
};
